module.exports = __webpack_public_path__ + "img/Picture38.e34dcc05.png";